import { render, staticRenderFns } from "./wxBomQuery.vue?vue&type=template&id=3f429ce7"
import script from "./wxBomQuery.vue?vue&type=script&lang=js"
export * from "./wxBomQuery.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports